<template>
  <div class="descriptionPage">
    <div v-show="show1">
      <description @enter="enter" @goBack="goBack">
        <template v-slot:content>
          在使用此项业务之前，请务必仔细阅读以下内容：<br />
          1.如您实际使用本项业务，则表示您同意遵守《WoYou工资服务及免责说明》和《WoYou工资隐私政策》的所有条款；<br />
          2.WoYou工资平台与广发银行达成深度合作，本平台为银行提供信息发布和链接跳转的技术服务，具体业务内容均由银行提供。对于业务过程中可能引发的任何纠纷或风险由用户承担，平台概不承担或负责；<br />
          3.根据法律法规及规范性文件的规定，银行提供业务办理时需要您提供如下必需信息：您的真实姓名、中国大陆身份证信息（身份证件号码、身份证件影像）、人脸照片；<br />
          4.通过该项业务办理的银行账户为信用卡账户；<br />
          5.银行需要完成反洗钱、实名认证、客户身份识别及授信额度评估等流程，有一定的办理周期。业务提交成功后可以在平台上查询银行反馈的业务进程，或留意银行的电话或短信通知。<br />
        </template>
      </description>
    </div>
    <el-dialog
      title=""
      :visible.sync="btnVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="440px"
      center
    >
      <div style="display: flex; justify-content: center; padding-top: 10px">
        <el-button
          type="primary"
          @click="addPersonnel"
          v-if="verifyPermission('Add')"
          >新增单人开卡</el-button
        >
        <el-button
          type="primary"
          @click="notifyCard"
          v-if="verifyPermission('Add')"
          >批量开卡</el-button
        >
        <el-button type="primary" @click="QRCard" v-if="verifyPermission('Add')"
          >小程序码开卡</el-button
        >
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          size="small "
          :loading="submitLoading"
          @click="btnVisible = false"
          >关 闭</el-button
        >
      </span>
    </el-dialog>
    <AddPersonel
      :drawerShow="addCustomerDrawerShow"
      :title="drawerTitle"
      operation="add"
      @colseDrawer="addCustomerDrawerShow = false"
      :bankInfoList="bankInfoList"
      type="2"
    />
    <notifyCard
      @colseDrawer="noticeDialogVisible = false"
      :visible.sync="noticeDialogVisible"
      :bankInfoList="bankInfoList"
    />
    <QRdig
      @close="QRVisible = false"
      :visible.sync="QRVisible"
      :bankInfoList="bankInfoList"
    />
    <!-- <transition name="el-zoom-in-bottom">
      <CardList v-if="show2" @noteCard="noteCard" />
    </transition> -->
  </div>
</template>

<script>
import CardList from "./CardList";
import description from "@/components/description";
import QRdig from "@/components/QRdig";
import { baseUrl } from "../../request/url";
import { GetUnlimitedQRCodeMinix } from "@/utils/mixin";
import { verifyPermissionMinix } from "@/utils/mixin";
import notifyCard from "/src/views/Card_manage/notifyCard";
import AddPersonel from "../talent_center/AddTalent";
export default {
  mixins: [verifyPermissionMinix, GetUnlimitedQRCodeMinix],
  components: {
    CardList,
    description,
    AddPersonel,
    notifyCard,
    QRdig,
  },
  props: {
    bankInfoList: Array,
  },
  data() {
    return {
      checked: false,
      form: {},
      QRVisible: false,
      drawerTitle: "",
      addCustomerDrawerShow: false,
      noticeDialogVisible: false,
      submitLoading: false,
      enterVisible: false,
      tipVisible: false,
      detail: "",
      show1: true,
      btnVisible: false,
      show2: false,
      mydata: "",
      baseUrl: baseUrl,
      operation: "",
    };
  },
  created() {
    // this.bankInfoList = JSON.parse(this.$route.query.bankInfoList);
    // console.log(JSON.parse(this.$route.query.bankInfoList));
    this.CompanyDetail();
  },
  methods: {
    QRCard() {
      this.qrcode();
    },
    qrcode() {
      this.submitLoading = true;

      this.bankInfoList.forEach((item, i) => {
        if (this.$shareType == 1) {
          let qrcode = new QRCode(item.bankName, {
            width: 100, // 设置宽度，单位像素
            height: 100, // 设置高度，单位像素
            text:
              baseUrl.website +
              "/#/pages/webView/transferPage?id=" +
              item.bankAutoIntId +
              "-" +
              item.autoIntId +
              "-" +
              item.userAutoIntId +
              "-" +
              item.CompanyAutoIntId,
            // 设置二维码内容或跳转地址
          });
          console.log(
            baseUrl.website +
              "/#/pages/webView/transferPage?id=" +
              item.bankAutoIntId +
              "-" +
              item.autoIntId +
              "-" +
              item.userAutoIntId +
              "-" +
              item.CompanyAutoIntId
          );
          this.submitLoading = false;
        }
        if (this.$shareType == 2) {
          let sendData = {
            page: "pages/webView/transferPage",
            check_path: false,
            width: 150,
            scene:
              "id=" +
              item.bankAutoIntId +
              "-" +
              item.autoIntId +
              "-" +
              item.userAutoIntId +
              "-" +
              item.CompanyAutoIntId,
          };
          this.toPage = `${baseUrl.appletPage}?scene=${sendData.scene}`;
          this.GetUnlimitedQRCode(sendData).then((res) => {
            item.imgPath = "data:image/png;base64," + res;
            if (this.bankInfoList.length - 1 == i) {
              this.submitLoading = false;
            }
            this.QRVisible = true;
          });
        }
      });
    },
    goBack() {
      this.$parent.show13();
    },
    notifyCard() {
      this.noticeDialogVisible = true;
    },
    nav() {
      let detail = JSON.stringify(this.form);
      let href = "/recommendation?detail=" + detail;
      window.open(href, "_blank");
      // this.$router.push("/recommendation");
    },
    noteCard(flag) {
      this.btnVisible = false;
      this.$parent.show1 = false;
      this.$parent.show2 = true;
      this.$parent.show3 = false;
    },
    addPersonnel() {
      this.operation = "add";
      this.addCustomerDrawerShow = true;
      this.drawerTitle = "新增人员开卡";
    },
    send() {
      this.show1 = !this.show1;
      this.show2 = !this.show2;
      this.tipVisible = false;
      this.enterVisible = false;
    },
    CompanyDetail() {
      this.$api.user.CompanyDetail().then((res) => {
        if (res.code === 0) {
          this.detail = res.data;
          window.localStorage.setItem(
            "CompanyDetail",
            JSON.stringify(res.data)
          );
          this.$store.commit("change", res.data);
          console.log(res);
        }
      });
    },
    resetForm() {},
    enter() {
      this.btnVisible = true;
    },
    drawermonstransVisibleClose() {
      this.$emit("close");
    },
    confirm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.tipVisible = true;
        }
      });
    },
  },
  watch: {},
};
</script>
<style lang="less">
.descriptionPage .el-dialog__body {
  padding: 10px 20px;
}
</style>
<style lang="less" scoped>
.descriptionPage {
  .title {
    text-align: center;
    font-size: 20px;
  }
  .content {
    padding: 20px 300px;
    line-height: 25px;
  }
  .btnBox {
    position: fixed;
    bottom: 60px;
    left: calc(50% - 82px);
    text-align: center;
    .btn {
      margin-top: 10px;
    }
  }
}
</style>